// Dependencies
import { createGlobalStyle } from 'styled-components';

const UtilitiesStyles = createGlobalStyle`
  // Spacing
  .spacing-none {
    padding-bottom: var(--spacing-none);
  }

  .spacing-small {
    padding-bottom: var(--spacing-small-mobile);
  }

  .spacing-standard {
    padding-bottom: var(--spacing-standard-mobile);
  }

  .spacing-large {
    padding-bottom: var(--spacing-large-mobile);
  }

  @media(min-width: 768px) {
    .spacing-small {
      padding-bottom: var(--spacing-small-desktop);
    }

    .spacing-standard {
      padding-bottom: var(--spacing-standard-desktop);
    }

    .spacing-large {
      padding-bottom: var(--spacing-large-desktop);
    }
  }


  // Heights
  .height-small > * {
    min-height: 14rem;
  }

  .height-standard > * {
    min-height: 20rem;
  }

  .height-large > * {
    min-height: 30rem;
  }

  .height-full > * {
    min-height: 100vh;
  }

  @media(min-width: 768px) {
    .height-small > * {
      min-height: 23rem;
    }

    .height-standard > * {
      min-height: 30rem;
    }

    .height-large > * {
      min-height: 40rem;
    }
  }

  // Widths
  @media(min-width: 768px) {
    .width-small .container {
      max-width: 45rem;
    }
  }

    @media(min-width: 992px) {
    .width-small .container {
      max-width: 55rem;
    }
  }

  @media(min-width: 1200px) {
    .width-small .container {
      max-width: 80rem;
    }
  }

    @media(min-width: 1400px) {
    .width-small .container {
      max-width: 90rem;
    }
  }
`;

export default UtilitiesStyles;
